export const CheckIcon = ({ color = '#667085' }) => {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#0090EA" />
        <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#0090EA" />
        <path d="M11.3333 5.5L6.74999 10.0833L4.66666 8" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

}